export const objectiveHealthQueryKeys = {
  objectives: {
    all: () => ['objectiveHealth'] as const,
    byId: (orgId: string, objectiveId: number, loopId?: number) =>
      ['objectiveHealth', orgId, objectiveId, { loopId }] as const,
    byIds: (orgId: string, objectiveIds: number[]) =>
      ['objectiveHealth', orgId, { ids: objectiveIds }] as const,
  },
};
